import { AnswerType, Question, VariableResponse } from '@/api/api.schemas';

export function isQuestionTriggered(data: Record<string, unknown>, question: Question): boolean {
  if (!question.triggeredByAnswerChoiceId) {
    return false;
  }

  const triggerId = question.triggeredByAnswerChoiceId.toString();
  return Object.values(data).some((val) => {
    if (Array.isArray(val)) {
      return val.includes(triggerId);
    }
    return val?.toString() === triggerId;
  });
}

export function parseResponse(response: VariableResponse, question: Question) {
  switch (question.answerType) {
    case AnswerType.slider10:
      return parseInt(response.response);
    case AnswerType.checkboxOther:
      return deserializeResponse(response.response);
    default:
      return response.response;
  }
}

export function deserializeResponse(response: string) {
  try {
    const parsedArray = JSON.parse(response);
    if (Array.isArray(parsedArray)) {
      return parsedArray;
    }
    return response;
  } catch {
    return response;
  }
}

export function getResponseName(questionId: number) {
  return `response${questionId}`;
}

export function getResponseOtherName(questionId: number) {
  return `response${questionId}Other`;
}
